export * from "./BettingGatewayConfigirations";
//# sourceMappingURL=index.js.map